module.exports = __webpack_public_path__ + "img/fb_icon.be912346.svg";